import { render, staticRenderFns } from "./StudentEditTabPhoneNumbers.vue?vue&type=template&id=7d0abefd&scoped=true&"
import script from "./StudentEditTabPhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabPhoneNumbers.vue?vue&type=script&lang=js&"
import style0 from "./StudentEditTabPhoneNumbers.vue?vue&type=style&index=0&id=7d0abefd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0abefd",
  null
  
)

export default component.exports